"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSlider = void 0;
var keen_slider_1 = __importDefault(require("keen-slider"));
require("keen-slider/keen-slider.min.css");
var tailwind_1 = require("../constants/tailwind");
var get_element_1 = require("../utils/get_element");
var SLIDER_IDS = {
    CONTAINER: 'js-slider',
    ARROW_LEFT: 'js-slider-arrow-left',
    ARROW_RIGHT: 'js-slider-arrow-right',
    DOTS: 'js-slider-dots',
    DOT: 'js-slider-dot',
};
var SLIDER_CLASSES = {
    DOT: 'slider-dot',
};
/**
 * スライダーの初期化
 * @param {KeenSliderOptions} options KeenSliderのオプション
 */
var setupSlider = function (options) {
    if (options === void 0) { options = { loop: true }; }
    new keen_slider_1.default("#".concat(SLIDER_IDS.CONTAINER), options, [navigation]);
};
exports.setupSlider = setupSlider;
/**
 * スライダーの矢印ボタンの初期化
 * @param slider スライダーのインスタンス
 */
var initSliderArrows = function (slider) {
    var arrowLeft = (0, get_element_1.getElementById)(SLIDER_IDS.ARROW_LEFT);
    var arrowRight = (0, get_element_1.getElementById)(SLIDER_IDS.ARROW_RIGHT);
    arrowLeft.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    arrowLeft.classList.add(tailwind_1.TAILWIND_CLASSES.FLEX);
    arrowRight.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    arrowRight.classList.add(tailwind_1.TAILWIND_CLASSES.FLEX);
    arrowLeft === null || arrowLeft === void 0 ? void 0 : arrowLeft.addEventListener('click', function () { return slider.prev(); });
    arrowRight === null || arrowRight === void 0 ? void 0 : arrowRight.addEventListener('click', function () { return slider.next(); });
};
/**
 * スライダーのドットの初期化
 * @param slider スライダーのインスタンス
 */
var initSliderDots = function (slider) {
    var dotsContainer = (0, get_element_1.getElementById)(SLIDER_IDS.DOTS);
    slider.track.details.slides.forEach(function (_, index) {
        var dot = document.createElement('div');
        dot.addEventListener('click', function () { return slider.moveToIdx(index); });
        dot.classList.add(SLIDER_CLASSES.DOT);
        dotsContainer === null || dotsContainer === void 0 ? void 0 : dotsContainer.appendChild(dot);
    });
};
/**
 * スライダーのドットのクラスを更新する
 * @param slider スライダーのインスタンス
 */
var updateDotClasses = function (slider) {
    var slideIndex = slider.track.details.rel;
    var dotsContainer = (0, get_element_1.getElementById)(SLIDER_IDS.DOTS);
    if (dotsContainer)
        Array.from(dotsContainer.children).forEach(function (dot, index) {
            if (index === slideIndex) {
                dot.classList.add(tailwind_1.TAILWIND_CLASSES.OPACITY_100);
            }
            else {
                dot.classList.remove(tailwind_1.TAILWIND_CLASSES.OPACITY_100);
            }
        });
};
/**
 * スライダーを矢印で操作する
 * @param slider スライダー操作関連のインスタンス
 */
var navigation = function (slider) {
    slider.on('created', function () {
        var _a;
        (_a = slider.container.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove(tailwind_1.TAILWIND_CLASSES.OPACITY_0);
        if (slider.slides.length > 1) {
            initSliderArrows(slider);
            initSliderDots(slider);
            updateDotClasses(slider);
        }
    });
    slider.on('slideChanged', function () {
        updateDotClasses(slider);
    });
};
